module.exports = __webpack_public_path__ + "media/Loops 110 Brass.aa8d9971.wav";